import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { StoreFinderComponent } from '../../../store/store-finder.component';
export interface IPageStoreFinderData extends NICmsContentComponent.IData {
    brandFilter: 'Helmet' | 'all';
    hideTags?: boolean;
}
@Component({
    selector: 'page-component-store-finder',
    template: `<store-finder [noGeolocationOnInit]="true" [brandFilter]="component.brandFilter" [hideTags]="component.hideTags" />`,
    standalone: true,
    imports: [StoreFinderComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
@ICmsComponent<PageStoreFinderComponent>({
    id: 'store-finder',
    name: 'Store finder',
    tags: ['stores', 'feature'],
    fields: [
        <NICmsContentField.IChoiceField>{
            type: NICmsContentField.EFieldType.choice,
            title: 'Brand filter',
            key: 'brandFilter',
            options: [
                { key: 'Helmet', title: 'Helmet' },
                { key: 'all', title: 'All' }
            ],
            default: 'all'
        },
        <NICmsContentField.IToggleField>{
            type: NICmsContentField.EFieldType.toggle,
            title: 'Hide tag',
            key: 'hideTags',
            default: false
        }
    ]
})
export class PageStoreFinderComponent extends UiComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'component'
    })
    component!: IPageStoreFinderData;
}
